<template>
  <div class="works-view">
    <h1>{{ title }}</h1>
    <SplittedContainer>
      <template slot="left">
        <TheCarousel
          :class="'is-fixed'"
          :images="images"
          :autoplay="false"
        />
      </template>
      <template slot="right">
        <TheProjects
          :class="'is-scrollable'"
          :categories="categories"
        />
      </template>
    </SplittedContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TheProjects from '@blocks/TheProjects'
import TheCarousel from '@blocks/TheCarousel'
import SplittedContainer from '@containers/SplittedContainer'
import View from '@mixins/View'

export default {
  name: 'WorksView',
  mixins: [ View ],
  components: {
    TheProjects,
    TheCarousel,
    SplittedContainer
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice',
      title: 'page/getTitle',
      categories: 'page/getCategories',
      images: 'page/getImages'
    })
  },
  created () {
    this.fetchGetPage({ name: 'works' })
  },
  methods: {
    ...mapActions({
      fetchGetPage: 'page/fetchGetPage'
    })
  }
}
</script>

<style lang="scss">
.works-view{
  width: 100%;
  height: 100%;
  background-color: black;
  padding-top: layout("spacing")*2;

  h1{
    @include hide-visually;
  }

  .carousel{
    @include media("large"){
      left: 0;
      right: initial;
    }
  }

  .projects{
    @include media("large"){
      margin-left: 50%;
      align-items: flex-start;
    }
  }
}
</style>
